module.exports = __webpack_public_path__ + "img/lab-1.a08bebef.svg";